'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnquiryTradeInsController = function () {
  function EnquiryTradeInsController($state, lookupService, enums, loadingService, enquiryService, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, EnquiryTradeInsController);
    this.$state = $state;
    this.lookupService = lookupService;
    this.enums = enums;
    this.loadingService = loadingService;
    this.enquiryService = enquiryService;
    this.$scope = $scope;

    this.lookupBrands();
    this.lookupBrandModels();

    this.getReturnParams = this.getReturnParams.bind(this);
    this.getReturnParamsEdit = this.getReturnParamsEdit.bind(this);
  }

  (0, _createClass3.default)(EnquiryTradeInsController, [{
    key: 'lookupBrands',
    value: function lookupBrands() {
      var ctrl = this;
      this.lookupService.lookupBrands().then(function (brands) {
        ctrl.brands = brands;
      });
    }
  }, {
    key: 'lookupBrandModels',
    value: function lookupBrandModels() {
      var ctrl = this;
      this.lookupService.lookupBrandModels().then(function (brandModels) {
        ctrl.brandModels = brandModels;
      });
    }
  }, {
    key: 'addTradeInVehicle',
    value: function addTradeInVehicle() {
      var _this = this;

      var epSettlement = (0, _lodash.find)(this.enquiry.enquiryPrices, function (o) {
        return o.groupType === _this.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts && o.name === 'Settlement';
      });
      var settlement = null;

      if (epSettlement) {
        settlement = epSettlement.amount;
      }

      var origin = {
        source: 'enquiry',
        processResult: this.getReturnParams
      };

      this.$state.go('vehicleTradeIn', { origin: origin, contactId: this.enquiry.contactId, enquiryId: this.enquiry.enquiryId, settlement: settlement });
    }
  }, {
    key: 'editTradeInVehicle',
    value: function editTradeInVehicle(vehicleId) {
      var _this2 = this;

      var epSettlement = (0, _lodash.find)(this.enquiry.enquiryPrices, function (o) {
        return o.groupType === _this2.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts && o.name === 'Settlement' && !o.removed;
      });
      var settlement = null;

      if (epSettlement) {
        settlement = epSettlement.amount;
      }

      var origin = {
        source: 'enquiry',
        processResult: this.getReturnParamsEdit
      };

      this.$state.go('editAppraisal', { vehicleId: vehicleId, origin: origin, contactId: this.enquiry.contactId, enquiryId: this.enquiry.enquiryId, settlement: settlement });
    }
  }, {
    key: 'getReturnParams',
    value: function getReturnParams(vehicleId, vehicleAppraisal, settlement) {
      var ctrl = this;
      var stateName = void 0;

      var params = {
        activeTab: 'tradeIns'
      };

      if (vehicleId) {
        ctrl.enquiry.tradeInVehicles.push({
          vehicleId: vehicleId,
          vehicle: vehicleAppraisal.vehicle,
          allowance: vehicleAppraisal.allowance,
          overAllowance: vehicleAppraisal.overAllowance || 0
        });
      }

      params.enquiry = ctrl.enquiry;

      var tradeInAll = (0, _lodash.find)(params.enquiry.enquiryPrices, function (o) {
        return o.name === 'Trade In Allowance(s)';
      });
      if (tradeInAll) {
        tradeInAll.amount = vehicleAppraisal.allowance;
      } else {
        params.enquiry.enquiryPrices.push({
          priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Discount,
          groupType: ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.VehiclePricing,
          name: 'Trade In Allowance(s)',
          amount: vehicleAppraisal.allowance,
          removed: false
        });
      }

      var epSettlement = (0, _lodash.find)(params.enquiry.enquiryPrices, function (o) {
        return o.groupType === ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts && o.name === 'Settlement';
      });

      if (epSettlement) {
        epSettlement.removed = false;
        epSettlement.amount = settlement;
      } else {
        params.enquiry.enquiryPrices.push({
          priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Cost,
          groupType: ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts,
          name: 'Settlement',
          amount: settlement,
          removed: false
        });
      }

      if (ctrl.enquiry.enquiryId) {
        stateName = 'enquiryEdit';
        params.enquiryId = ctrl.enquiry.enquiryId;
      } else {
        stateName = 'enquiryAdd';
      }

      return {
        stateName: stateName,
        params: params
      };
    }
  }, {
    key: 'getReturnParamsEdit',
    value: function getReturnParamsEdit(vehicleId, vehicleAppraisal, settlement) {
      var ctrl = this;
      var stateName = void 0;

      var params = {
        activeTab: 'tradeIns'
      };

      if (vehicleId) {
        var tradeInVehicle = (0, _lodash.find)(ctrl.enquiry.tradeInVehicles, function (o) {
          return o.vehicleId === vehicleId;
        });

        tradeInVehicle.allowance = vehicleAppraisal.allowance;
        tradeInVehicle.overAllowance = vehicleAppraisal.overAllowance || 0;
      }

      params.enquiry = ctrl.enquiry;

      var tradeInAll = (0, _lodash.find)(params.enquiry.enquiryPrices, function (o) {
        return o.name === 'Trade In Allowance(s)';
      });
      if (tradeInAll) {
        tradeInAll.amount = vehicleAppraisal.allowance;
      } else {
        params.enquiry.enquiryPrices.push({
          priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Discount,
          groupType: ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.VehiclePricing,
          name: 'Trade In Allowance(s)',
          amount: vehicleAppraisal.allowance,
          removed: false
        });
      }

      var epSettlement = (0, _lodash.find)(params.enquiry.enquiryPrices, function (o) {
        return o.groupType === ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts && o.name === 'Settlement';
      });
      if (epSettlement) {
        epSettlement.amount = settlement;
        if (settlement) {
          epSettlement.removed = false;
        }
      } else {
        params.enquiry.enquiryPrices.push({
          priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Cost,
          groupType: ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts,
          name: 'Settlement',
          amount: settlement,
          removed: false
        });
      }

      if (ctrl.enquiry.enquiryId) {
        stateName = 'enquiryEdit';
        params.enquiryId = ctrl.enquiry.enquiryId;
      } else {
        stateName = 'enquiryAdd';
      }

      return {
        stateName: stateName,
        params: params
      };
    }
  }, {
    key: 'gotoVehicle',
    value: function gotoVehicle(v) {
      this.$state.go('vehicleEdit', {
        vehicleId: v.vehicle.vehicleId,
        origin: {
          source: 'enquiry',
          enquiryId: this.enquiry.enquiryId
        }
      });
    }
  }, {
    key: 'existingTradeIn',
    value: function existingTradeIn() {
      var _this3 = this;

      var ctrl = this;

      ctrl.loadingService.showLoading('tradeIns', 'Adding Trade In ...');

      ctrl.enquiryService.addExistingTradeIn(ctrl.enquiry.enquiryId).then(function (response) {
        //Push Trade In
        ctrl.enquiry.tradeInVehicles.push(response.data);

        //Push price
        var tradeInAllowance = (0, _lodash.find)(ctrl.enquiry.enquiryPrices, function (o) {
          return o.name === 'Trade In Allowance(s)';
        });
        tradeInAllowance.amount = response.data.allowance;

        //Update Calc through Event
        ctrl.$scope.$emit('enquiry:proxyEvent', { eventName: 'vehicleSelected' });
      }).catch(function (err) {
        if (err.status === 400) {
          //Bad Request
          ctrl.state = 'ModelError';

          if (err.data.map) {
            err.data.map(function (item) {
              ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
            });
          } else {
            ctrl.formValidationService.addSystemError(null, err.data);
          }
        } else if (err.status === 500) {
          ctrl.state = 'SystemError';
          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
        }
      }).finally(function () {
        _this3.loadingService.hideLoading('tradeIns');
      });
    }
  }]);
  return EnquiryTradeInsController;
}();

exports.default = EnquiryTradeInsController;


// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiryEdit/enquiryTradeIns/enquiryTradeIns.controller.js